export default "https://cdn-static.gokick.com/assets/3759ced803c9aed0ddbd8c13c713c33e7dde05d8/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";